export const VS_KEY_TO_PAIR = {
    none: ['none', 'none'],
    medium: ['medium', 'medium'],
    large: ['large', 'large'],
    'no-top': ['none', 'medium'],
    'no-bottom': ['medium', 'none'],
    'large-medium-top': ['medium', 'large'],
    'large-medium-bottom': ['large', 'medium'],
    'large-no-top': ['none', 'large'],
    'large-no-bottom': ['large', 'none'],
} as const;

type VerticalSpacingKey = keyof typeof VS_KEY_TO_PAIR;

type VerticalSpacingValue = (typeof VS_KEY_TO_PAIR)[VerticalSpacingKey][number];

export const PAIR_TO_VS_KEY: Record<string, VerticalSpacingKey> =
    Object.fromEntries(
        Object.entries(VS_KEY_TO_PAIR).map(([key, value]) => [
            value.join('|'),
            key,
        ])
    ) as Record<string, VerticalSpacingKey>;

export function parseVerticalSpacingKey(value: unknown = 'medium'): {
    top: VerticalSpacingValue;
    bottom: VerticalSpacingValue;
} {
    const [top, bottom] = VS_KEY_TO_PAIR[
        String(value) as VerticalSpacingKey
    ] ?? ['medium', 'medium'];

    return { top, bottom };
}

export function buildVerticalSpacingKey(
    top: VerticalSpacingValue = 'medium',
    bottom: VerticalSpacingValue = 'medium'
): VerticalSpacingKey | null {
    return PAIR_TO_VS_KEY[`${top}|${bottom}`] ?? null;
}

export function isValidVerticalSpacing(top: unknown, bottom: unknown): boolean {
    return Boolean(PAIR_TO_VS_KEY[`${String(top)}|${String(bottom)}`]);
}
